import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF } from '../../../Layout/tokens';

const PANELS: Record<string, TypedGroupviewPanelState> = {
  orderMonitoring: {
    id: 'orderMonitoring',
    contentComponent: 'orderMonitoring',
    title: 'Orders',
    params: { type: 'orderMonitoring' },
  },
  tradeMonitoring: {
    id: 'tradeMonitoring',
    contentComponent: 'tradeMonitoring',
    title: 'Trades',
    params: { type: 'tradeMonitoring' },
  },
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        visible: true,
        data: { views: ['orderMonitoring'], activeView: 'orderMonitoring', id: 'orderMonitoring' },
        size: 450,
      },
      {
        type: LEAF,
        visible: true,
        data: { views: ['tradeMonitoring'], activeView: 'tradeMonitoring', id: 'tradeMonitoring' },
        size: 450,
      },
    ],
    size: 1600,
  },
  width: 1600,
  height: 900,
  orientation: Orientation.VERTICAL,
};

export const ORDERS_TRADES_MONITORING_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
